import { AfterViewInit, Component, ComponentRef, Injector, Input, OnDestroy, ViewChild, ViewContainerRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { IdentityServicePathComponent } from 'ziti-console-lib';
import { VisualizerDialogHostComponent } from './visualizer-dialog-host.component';

@Component({
    selector: 'netfoundry-ui-identity-visualizer-tab',
    templateUrl: './identity-visualizer-tab.component.html',
    styleUrls: ['./identity-visualizer-tab.component.scss'],
    standalone: false
})
export class IdentityVisualizerTabComponent implements AfterViewInit, OnDestroy {
    @Input() data: any;

    @ViewChild('visualizerHost', { read: ViewContainerRef, static: true }) host!: ViewContainerRef;

    // Lets the embedded IdentityServicePathComponent's own close button (which
    // calls `dialogRef.close()`) close the full-screen dialog when the view has
    // been moved there. No-op while embedded in the tab.
    private dialogCloseCallback = () => {};

    private visualizerRef?: ComponentRef<IdentityServicePathComponent>;

    constructor(private injector: Injector, private dialog: MatDialog) {}

    ngAfterViewInit() {
        this.createEmbeddedVisualizer();
    }

    ngOnDestroy() {
        this.host?.clear();
    }

    openFullScreen() {
        const view = this.host.detach(0);
        if (!view) {
            return;
        }
        const dialogRef = this.dialog.open(VisualizerDialogHostComponent, {
            panelClass: 'visualizer-fullscreen-dialog',
            autoFocus: false,
        });
        dialogRef.componentInstance.host.insert(view);
        if (this.visualizerRef) {
            this.visualizerRef.instance.fullScreen = true;
        }
        this.dialogCloseCallback = () => dialogRef.close();

        // beforeClosed (not afterClosed): once the dialog finishes closing, Angular
        // Material destroys VisualizerDialogHostComponent's view (and everything
        // moved into it) along with the overlay, so the view must be reclaimed
        // before that teardown runs.
        dialogRef.beforeClosed().subscribe(() => {
            this.dialogCloseCallback = () => {};
            if (this.visualizerRef) {
                this.visualizerRef.instance.fullScreen = false;
            }
            const returned = dialogRef.componentInstance.host.detach(0);
            if (returned) {
                this.host.insert(returned);
            } else {
                this.createEmbeddedVisualizer();
            }
        });
    }

    private createEmbeddedVisualizer() {
        const childInjector = Injector.create({
            providers: [
                { provide: MAT_DIALOG_DATA, useValue: { identity: { ...this.data?.model } } },
                { provide: MatDialogRef, useValue: { close: () => this.dialogCloseCallback() } },
            ],
            parent: this.injector,
        });
        this.visualizerRef = this.host.createComponent(IdentityServicePathComponent, { injector: childInjector });
    }
}
